import { getAppConfig } from "./app-config.js";
function getTenantSubdomain(hostname = window.location.hostname) {
    return hostname.split('.')[0];
}
function getTenantNamespace() {
    return getAppConfig().tenantNamespace;
}
export { getTenantNamespace, getTenantSubdomain };

//# sourceMappingURL=tenant.js.map